import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../theme/style-helpers';

export const Container = styled.div`
    position: fixed;
    top: 0; bottom: 0;
    right: 0; left: 0;
    z-index: 201;
    display: ${({ isopen }) => (isopen === 'true' ? 'block' : 'none')};
    ${MediaQuery.medium(css`
        position: absolute;
        top: 100%; 
        right: 0;
        bottom: unset;
        left: unset;
        margin-top: 8px;
    `)};
`;

export const BackgroundBlur = styled.div`
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(2px);

    ${MediaQuery.medium(css`
        display: none;
    `)};
`;

export const ItemsContainer = styled.div`
    padding-bottom: 24px;
    display: grid;
    grid-auto-flow: row;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 4px 4px 0px 0px;
    background-color: #F2F2F2;
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 1;

    ${MediaQuery.medium(css`
        position: unset;
        width: max-content;
        background: #F2F2F2;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
        border-radius: 0px 0px 4px 4px;
        padding: 12px 24px;
    `)};
`;

export const CloseButtonContainer = styled.div`
    display: flex;
    padding: 20px;
    justify-content: flex-end;
    border-bottom: 1px solid #D9D9D6;
    margin-bottom: 8px;

    ${MediaQuery.medium(css`
        display: none;
    `)};
`;

export const CloseButton = styled.button`
    display: flex;
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    cursor: pointer;
`;

export const Item = styled.div`
    padding: 16px 24px;
    display: grid;
    grid-template-columns: 20px auto;
    column-gap: 8px;
    align-items: center;
    cursor: pointer;

    ${MediaQuery.medium(css`
        padding: 12px 0;
    `)};    
`;

export const ItemLabel = styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: ${colors.BLACK};
    text-align: left;
`;

export const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
    display:flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
`;

export const ModalContent = styled.div`
    position: absolute;
    top: 0; bottom: 0;
    left: 0; right: 0;
    background: #F9F9F9;
    padding: 72px 24px;
    display: flex;
    flex-direction: column;
    gap: 64px;

    ${MediaQuery.medium(css`
        padding: 80px 48px 64px;
        border-radius: 4px;
        position: relative;
        display: grid;
        grid-auto-flow: row;
        row-gap: 64px;
        max-width: 648px;
    `)};
`;

export const CloseModalButton = styled.div`
    position: absolute;
    top: 24px;
    right: 24px;
    cursor: pointer;
`;

export const ModalInfo = styled.div`
    display: grid;
    grid-auto-flow: row;
    justify-items: center;
    row-gap: 12px;
`;

export const ModalTitle = styled.h3`
    margin: 0;
    font-weight: 500;
    font-size: 28px;
    line-height: 130%;
    color: ${colors.BLACK};
`;

export const ModalDescription = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: ${colors.BLACK};
    text-align: center;
`;

export const ModalCTAs = styled.div`
    display: flex;
    flex-direction: column-reverse;
    gap: 24px;

    ${MediaQuery.medium(css`
        flex-direction: row;
        gap: 32px;
        justify-self: center;
    `)};
`;
